import { cn } from '@/lib/utils';

/**
 * Spinner shown while pulling / refreshing. Render as the first child of the
 * `position: relative` scroll container driven by `usePullToRefresh`.
 */
export default function PullToRefreshSpinner({
  pullY,
  refreshing,
  threshold = 70,
}: {
  pullY: number;
  refreshing: boolean;
  threshold?: number;
}) {
  if (pullY <= 0 && !refreshing) return null;
  return (
    <div
      className="tw:pointer-events-none tw:absolute tw:inset-x-0 tw:top-0 tw:z-20 tw:flex tw:justify-center"
      style={{ transform: `translateY(${refreshing ? 12 : pullY - 24}px)` }}
    >
      <span
        className={cn(
          'tw:size-7 tw:rounded-full tw:border-2 tw:border-white/20 tw:border-t-blue-primary',
          (refreshing || pullY >= threshold) && 'tw:animate-spin',
        )}
      />
    </div>
  );
}
